import { useState } from 'react';
import { size } from '@/constants/page';

export default () => {
  const [cloudList, setCloudList] = useState<any>(
    Array.from({ length: size }, (_, index) => ({ id: index + 1, mock: true }))
  );

  return {
    cloudList,
    setCloudList
  }
}
